/**
 * Created by Ning Jiang on 6/20/2018.
 */

import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {ZeroBetManager} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetManager";
import {ScreenManager} from "@nolimitcity/slot-game/bin/core/screen/ScreenManager";
import {FruitsParsedGameData} from "../server/data/FruitsParsedGameData";
import {FruitsParsedInitData} from "../server/data/FruitsParsedInitData";
import {FruitsGameMode} from "../gamemode/FruitsGameMode";

export class FruitsSpinController extends SpinController {

    private _stickyReels:boolean[];
    private _idleReels:boolean[] = [false, false, false, false, false, false, false, false, false, false, false, false,
        false, false, false, false];

    constructor() {
        super();
    }

    protected parseGameData(data:FruitsParsedGameData | FruitsParsedInitData):void {
        this._stickyReels = !this.isRespinMode(data.nextMode) ? this._idleReels : (data instanceof FruitsParsedGameData) ? data.overlayStickySymbolsAfterSpin : data.overlayStickySymbols;
    }

    protected getReelsGameConfigFromPreviousGameData():boolean[] {

        return this._stickyReels.map(x => !x);
    }

    private isRespinMode(currentMode:FruitsGameMode):boolean {
        return currentMode === FruitsGameMode.STICKY_RESPIN;
    }
}